export default __webpack_public_path__ + "static/media/fb32555db4aed9db3528be1a6197fe4e.svg";